import { render, staticRenderFns } from "./majors.vue?vue&type=template&id=35137103&scoped=true"
import script from "./majors.vue?vue&type=script&lang=js"
export * from "./majors.vue?vue&type=script&lang=js"
import style0 from "./majors.vue?vue&type=style&index=0&id=35137103&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35137103",
  null
  
)

export default component.exports